export default {
  back: 'Terug naar campagnes',
  title: 'Campagne',
  sent_at: 'Verzonden {{time}}',
  breakdown_title: 'Bezorgingsoverzicht',
  pending_receipts: {
    title: 'Bezorgstatistieken zijn onderweg',
    description:
      'Deze campagne is zojuist verzonden. Push-providers bevestigen bezorging ongeveer 15 minuten na verzending, dus de cijfers hieronder worden rond {{time}} ingevuld — geen actie vereist.',
    countdown:
      'Apple en Google bevestigen ontvangsten in ongeveer {{minutes}}m {{seconds}}s (rond {{time}}). De statistieken worden automatisch vernieuwd.',
    ready: 'Ontvangstbewijzen zouden binnen moeten zijn. De cijfers hieronder worden nu vernieuwd.',
    soon: 'binnenkort',
  },
  recipients: {
    title: 'Ontvangers',
    subtitle: 'Naar wie deze campagne is verzonden en of deze hun apparaat heeft bereikt.',
    filters: {
      all: 'Alle',
      delivered: 'Bezorgd',
      pending: 'In afwachting van bevestiging',
      failed: 'Niet bezorgd',
    },
    columns: {
      recipient: 'Ontvanger',
      status: 'Status',
      reason: 'Reden',
      clicked: 'Geklikt',
      sent_at: 'Verzonden om',
    },
    status: {
      delivered: 'Bezorgd',
      pending: 'In afwachting van bevestiging',
      failed: 'Niet bezorgd',
    },
    reasons: {
      DeviceNotRegistered: 'App verwijderd of meldingen uitgeschakeld (verlopen token)',
      MessageRateExceeded: 'Tijdelijk beperkt door Expo',
      MessageTooBig: 'Meldingspayload te groot',
      MismatchSenderId: 'Push-inloggegevens komen niet overeen',
      InvalidCredentials: 'Ongeldige push-inloggegevens',
      batch_failed: 'Batchverzending mislukt',
      missing_ticket: 'Geen bevestiging ontvangen van Expo',
      unknown: 'Onbekende bezorgfout',
    },
  },
};
